import { IUpNextItem } from '@ifit/gateway-wolf-dashboard-service';
import { UseQueryResult } from 'react-query';
import { useUpNextItems } from './use-up-next-items';

export function useUpNextForYouItems(disableCall: boolean): UseQueryResult<IUpNextItem[], Error> {
  function removeParamountItemFrom(upNextItems: IUpNextItem[]): IUpNextItem[] {
    return upNextItems.slice(1);
  }

  const query = useUpNextItems(disableCall);
  query.data = query.data ? removeParamountItemFrom(query.data) : undefined;
  return query;
}
